/* Thoson: copy que se ajusta en el navegador.
   Cargado desde sections/thx-header.liquid. Es la misma capa de siempre:
   no se edita ninguna seccion, ningun snippet y ninguno de los 49
   product.*.json. Borrar la linea del header lo revierte entero.

   Tres tablas y una regla comun: la clave es el texto original tal y como
   esta hoy en el tema. Si manana lo cambias en el personalizador, la clave
   deja de coincidir y lo que se ve es lo tuyo, no lo de aqui. Nada se
   sobreescribe a ciegas.

   norm() iguala los dos lados antes de comparar: espacios, comillas rectas
   y curvas, y las rayas largas, que thx-global.js ya convierte en coma
   antes de que esto corra porque se carga desde el head.
   ---------------------------------------------------------------- */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function norm(text) {
    return (text || '')
      .replace(/\s+/g, ' ')
      .replace(/[‘’]/g, "'")
      .replace(/[“”]/g, '"')
      .replace(/\s*[,;]?\s*[–—]\s*/g, ', ')
      .trim();
  }

  /* ----------------------------------------------------------------
     1. El CTA del hero.

     "Shop the bestseller" nombraba la transaccion. El nuevo nombra el
     resultado, que es lo que el padre viene a buscar. El destino no se
     toca: sigue yendo a Best Sellers.

     El enlace lleva una flecha en SVG detras del texto, asi que se
     reemplaza solo el primer nodo de texto y el SVG se queda donde esta.
     ---------------------------------------------------------------- */
  var HERO_OLD = 'Shop the bestseller';
  var HERO_NEW = 'Start Learning Through Play';

  function heroCta() {
    var cta = document.querySelector('.thx-hero__cta');
    if (!cta) return;
    var node = cta.firstChild;
    while (node && node.nodeType !== 3) node = node.nextSibling;
    if (!node) return;
    if (norm(node.data) !== HERO_OLD) return;
    node.data = HERO_NEW;
  }

  /* ----------------------------------------------------------------
     2. El titulo de la tira de colecciones del buy box.

     "Jump to Our Collections" nombra el mecanismo, no el motivo. Un padre
     que acaba de leer que hay dentro de la caja no quiere saltar a un
     indice: quiere ver si hay algo mas que le sirva.

     El titulo vive en un bloque de Custom Liquid dentro de los 49
     product.*.json, asi que cambiarlo en el origen serian 49 archivos de
     40 a 90KB. Aqui es una linea, y sigue la misma regla que el resto: si
     manana lo cambias tu, la clave deja de coincidir y manda el tuyo.
     ---------------------------------------------------------------- */
  var NAV_OLD = 'Jump to Our Collections';
  var NAV_NEW = "More Toys They'll Love";

  function navTitle() {
    var titles = document.querySelectorAll('.tn-dyn-section__title');
    Array.prototype.forEach.call(titles, function (el) {
      if (norm(el.textContent) !== NAV_OLD) return;
      el.textContent = NAV_NEW;
    });
  }

  /* ----------------------------------------------------------------
     3. La banda del buy box, igualada en los 40 productos.

     El bloque review_avatars pinta dos lineas: la de "Trusted by" y,
     encima de ella (order -1), una banda con un gancho. Esa banda la
     fue escribiendo alguien producto a producto segun se lanzaban: 24
     de los 40 dicen ya "Take Back Control From Screens", y los 15
     ultimos llevan cada uno lo suyo ("7 LED Colors Mist, Roar, Walk" en
     Apex, "A Working Site Load, Haul, Dump" en Quarry, "Glows in The
     Dark" en Sandlab).

     Aqui se igualan todos al de Thoson Bot. La banda se reconoce por
     descarte: dentro de .review-avatars es el .review-avatars__text que
     NO lleva .review-avatars__text-1, que es la clase de "Trusted by".

     Esta es la unica pieza del archivo que no se ancla al texto viejo,
     porque el texto viejo es distinto en cada producto. Se ancla al
     nuevo: si la banda ya dice lo que tiene que decir, no se toca. El
     precio de eso es que editarla en el personalizador ya no se vera;
     para cambiarla hay que cambiar BAND_TOP y BAND_BOTTOM de aqui.

     El markup se reconstruye con nodos de texto, no pegando HTML, y
     copia la forma exacta que tiene Bot: la primera linea en <strong> a
     1.4rem y la segunda en <em><strong> a 1.2rem con el emoji suelto
     detras.
     ---------------------------------------------------------------- */
  var THX_ES = /^es\b/i.test(document.documentElement.lang || '');
  var BAND_TOP = THX_ES ? 'Recupera el Control' : 'Take Back Control';
  var BAND_BOTTOM = THX_ES ? 'De Las Pantallas ' : 'From Screens ';
  var BAND_TAIL = '🏆';

  function screenBand() {
    var rows = document.querySelectorAll(
      '.product__info-container .review-avatars .review-avatars__text'
    );
    Array.prototype.forEach.call(rows, function (row) {
      if (String(row.className).indexOf('review-avatars__text-1') > -1) return;

      var parts = row.querySelectorAll('.font-size');
      if (parts.length < 2) return;

      if (
        norm(parts[0].textContent) === norm(BAND_TOP) &&
        norm(parts[1].textContent) === norm(BAND_BOTTOM + BAND_TAIL)
      ) {
        return;
      }

      var top = document.createElement('strong');
      top.textContent = BAND_TOP;
      parts[0].textContent = '';
      parts[0].appendChild(top);

      var em = document.createElement('em');
      var strong = document.createElement('strong');
      strong.textContent = BAND_BOTTOM;
      em.appendChild(strong);
      parts[1].textContent = '';
      parts[1].appendChild(em);
      parts[1].appendChild(document.createTextNode(BAND_TAIL));
    });
  }

  /* ----------------------------------------------------------------
     4. El tag de urgencia, encima del titulo.

     Con la chapa de resenas al lado, al tag le quedan 210px de ancho
     util a 375px, que son 26 caracteres. De los 40 tags de la tienda
     solo 3 cabian en una linea.

     Pero el recorte era la mitad del problema. La otra mitad: catorce
     productos decian "GUILT-FREE SCREEN TIME REPLACEMENT", que es lo
     mismo que dice la banda azul ocho pixeles mas abajo, y el resto
     describia el juguete ("TWO CARS. TWO REMOTES.") en vez de decirle
     al padre que pasa en su casa.

     Estos 39 estan escritos desde la ficha de cada producto, en punto
     de vista del comprador adulto, con el beneficio del hijo delante.
     Cada linea sale de una frase que la propia descripcion ya dice, asi
     que ninguna afirma nada que la tienda no pueda respaldar. Sin culpa
     parental, sin comparar con otros ninos, sin hablarle al nino y sin
     claims clinicos que la ficha no sostenga.

     La clave es doble: el handle del producto Y el texto viejo. Lo
     primero porque doce productos compartian el mismo tag generico y
     cada uno necesita el suyo. Lo segundo porque es la regla de todo
     este archivo: si manana lo cambias en el personalizador, la clave
     deja de coincidir y se ve lo tuyo.
     ---------------------------------------------------------------- */
  var TAGS = {
    'thoson-bot-full-pack™': ['GUILT-FREE SCREEN REPLACEMENT', 'FROM I CAN\'T TO I MADE IT'],
    'wonder-magic-art-full-pack': ['BUILT FOR YOUR CREATIVE ARTISTS', 'ALL PAINT, NO CLEANUP'],
    'magic-art-full-pack™-copy': ['GUILT-FREE SCREEN TIME REPLACEMENT', '50 MORE, STILL NO MESS'],
    '12-color-marker-refill-pack-thoson-bot': ['GUILT-FREE SCREEN TIME REPLACEMENT', 'IT ALL WASHES OFF'],
    'nestwood-full-pack™': ['GUILT-FREE SCREEN TIME REPLACEMENT', 'THE ONE THEY COME BACK TO'],
    'spell-play-full-pack™': ['GUILT-FREE SCREEN TIME REPLACEMENT', 'SPELLING THEY ASK FOR'],
    'numbernest-full-pack™': ['GUILT-FREE SCREEN TIME REPLACEMENT', 'MATH THEY CAN HOLD'],
    'thoson-blocks-full-pack™': ['BUILT FOR BRILLIANT MINDS', 'BUILT, WRECKED, REBUILT'],
    'thoson-lizard-play-pack™': ['GUILT-FREE SCREEN TIME REPLACEMENT', 'OFF THE COUCH, UP THE WALL'],
    'thoson-magic-gel': ['GUILT-FREE SCREEN TIME REPLACEMENT', 'THEY MADE THAT THEMSELVES'],
    'thoson-aquadoodle-book™': ['BUILT FOR BRILLIANT MINDS', 'QUIET IN THE CAR, NO INK'],
    'thoson-turbomonster-pack™': ['GUILT-FREE SCREEN TIME REPLACEMENT', 'BUILT TO BE CRASHED'],
    'thoson-microscope-explorer™': ['GUILT-FREE SCREEN TIME REPLACEMENT', 'EVERY BUG IS A QUESTION'],
    'thoson-spiderracer-duo': ['GUILT-FREE SCREEN TIME REPLACEMENT', 'TWO KIDS, ONE RACE'],
    'thoson-magtrack™': ['GUILT-FREE SCREEN TIME REPLACEMENT', 'THEY ENGINEER THE TRACK'],
    'magtrack™-train': ['GUILT-FREE SCREEN TIME REPLACEMENT', 'BOTH KIDS, BOTH TRAINS'],
    'snaptalk-duo': ['SAFE COMMUNICATION KIDS LOVE, PARENTS TRUST', 'A FIRST CALL, NO PHONE'],
    'thoson-wordplay': ['GUILT-FREE SCREEN REPLACEMENT', 'SPELLING, MISTAKEN FOR FUN'],
    'thoson-spark-™': ['MAKE THEM THINK. SEE THEM GLOW.', 'THEIR FIRST IT WORKS!'],
    'thoson-lingo': ['READING STARTS WITH PLAY', 'READING ON THEIR OWN'],
    'thoson-squishblocks': ['MAKE THEM THINK. SEE THEM GLOW.', 'SOFT BLOCKS, QUIET HANDS'],
    'thoson-buildbox': ['MAKE THEM THINK. SEE THEM GLOW.', 'REAL TOOLS, SMALL HANDS'],
    'thoson-fracsnap™': ['MAKE THEM THINK. SEE THEM GLOW.', 'FRACTIONS THEY CAN HOLD'],
    'thoson-skypop™': ['ONE BUTTON. A SKY FULL OF BUBBLES.', 'PUSH IT, THEY RUN OUTSIDE'],
    'thoson-lettercrew™': ['BUILD THE WORD. BUILD THE READER.', 'ALPHABET IN THEIR HANDS'],
    'thoson-shapecrew™': ['BUILD THE PATTERN. BUILD THE BRAIN.', 'PATTERNS, THEN THEIR OWN'],
    'thoson-pixelforge™': ['BUILD WORLDS. NOT WATCH THEM.', 'QUIET, CLICK BY CLICK'],
    'thoson-sandlab': ['SENSORY PLAY. WITHOUT THE MESS.', 'SAND THAT SNAPS SHUT'],
    'thoson-100-000-whys™': ['EVERY \'BUT WHY?\' ANSWERED. ZERO SCREENS.', 'A BOOK THAT KEEPS UP'],
    'thoson-readladder': ['THE READING PRACTICE KIDS ACTUALLY ASK TO DO.', 'ONE RUNG AT A TIME'],
    'thoson-pippo': ['THE PUP THAT TURNS POINTING INTO WORDS.', 'POINTING TURNS INTO WORDS'],
    'thoson-chime': ['THE QUIETEST, PRETTIEST TOY IN THE HOUSE.', 'THE TOY THAT CALMS A ROOM'],
    'thoson-monet': ['REAL PAINTING. ZERO MESS. JUST ADD WATER.', 'NO POTS, NO STAINED SHIRTS'],
    'thoson-quarry': ['EVERY OTHER TRUCK ENDS UP PARKED. NOT THIS ONE.', 'NOT ANOTHER PARKED TRUCK'],
    'thoson-clash': ['ONE MORE ROUND. NO SCREEN. YOUR AFTERNOON BACK.', 'NO ADULT REFEREE NEEDED'],
    'thoson-apex': ['IT WALKS. IT ROARS. IT BREATHES GLOWING MIST.', 'IT WALKS, ROARS, BREATHES'],
    'thoson-blitz': ['LIGHTS. SPEED. LEVELS. AND A MUTE BUTTON.', 'IT HAS A MUTE BUTTON'],
    'thoson-run': ['IT LAYS THE ROW. YOUR HANDS STAY OUT OF IT.', 'IT LAYS THE ROW FOR THEM'],
    'thoson-squishy-advent': ['TWENTY FOUR DOORS. NOTHING GETS EATEN.', 'NOT GONE IN 30 SECONDS'],
  };

  function productHandle() {
    var m = window.meta && window.meta.product;
    if (m && m.handle) return m.handle;
    var sa = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (sa && sa.product && sa.product.handle) return sa.product.handle;
    var path = location.pathname.split('/products/')[1];
    if (!path) return '';
    try { return decodeURIComponent(path.split('?')[0].split('/')[0]); }
    catch (e) { return ''; }
  }

  function urgencyTag() {
    var tag = document.querySelector('.product__info-container .urgency-text');
    if (!tag) return;

    var pair = TAGS[productHandle()];
    if (!pair) return;

    var now = norm(tag.textContent);
    if (now === norm(pair[1])) return;
    if (now !== norm(pair[0])) return;

    var host = tag.querySelector('strong') || tag;
    host.textContent = pair[1];
  }

  /* ----------------------------------------------------------------
     5. El testimonial del buy box.

     Medidos los 40 productos, la resena iba de 110 a 524 caracteres, asi
     que cada caja de compra tenia una altura distinta. Los que se ven bien
     estan todos por debajo de 275. Estos doce pasaban de 280 y aqui bajan
     a la misma franja, con sus mismas palabras y su misma voz: no se
     anade nada, solo se quita.

     La clave es el arranque de la resena original, que es unico entre los
     cuarenta, para no cargar el archivo con el texto largo entero.
     ---------------------------------------------------------------- */
  var REVIEW_SHORT = [
    ["My son has a bin of dinosaurs he stopped touchi", "My son has a bin of dinosaurs he stopped touching a year ago, so I expected this one to end up there too. Then it walked across the kitchen roaring, mist rolling out, lights turning the cloud red then blue. He screamed. Good screaming. First toy in a long time that beat the tablet."], /* thoson-apex */
    ["Our house was drowning in plastic toys that bee", "Our house was drowning in plastic toys that beep and flash, and it was wearing all of us out. This is the opposite. My son drops a marble, it tumbles down the little leaves making the softest wooden ding, and he just watches. Calm. Focused. No batteries, no noise, no screen."], /* thoson-chime */
    ["I bought this hoping it would survive one car r", "I bought this hoping it would survive one car ride. We are three weeks in and it still lives in his backpack. What actually sold me is the sound button. I turned it all the way down at the restaurant and he did not even notice, he just kept playing."], /* thoson-blitz */
    ["My son was almost two and still pointed at ever", "My son was almost two and still pointed at everything instead of saying it. He presses the puppy, hears the word in a clear voice, and taps repeat until he tries it himself. 'Ball' was his first clear word and I teared up right there in the kitchen."], /* thoson-pippo */
    ["I put off real painting for a year because I co", "I put off real painting for a year because I could not face the cleanup. The paint is printed right on the page, so she dips the brush in water and paints an actual dinosaur in actual watercolor. Three books in and my table has not seen a single stain."], /* thoson-monet */
    ["Reading practice used to mean groans and a figh", "Reading practice used to mean groans and a fight every single night. These cards feel like a game, so my daughter actually asks to do them. A few weeks in she read a full sentence out loud. She had no idea she was even doing schoolwork."], /* thoson-readladder */
    ["My 8-year-old asks why about everything and I'd", "My 8-year-old asks why about everything and I'd started saying 'I don't know, go Google it.' Now he looks up why we dream, why food goes bad, why we get goosebumps. Last night he read past bedtime instead of begging for the tablet."], /* thoson-whys */
    ["We did the chocolate one last year and by the e", "We did the chocolate one last year and by the eighth it was just sugar before school. This one she opens at breakfast, squeezes it, and lines it up on the shelf. By Christmas Eve there was a whole row. They are still up there in February."], /* thoson-advent */
    ["My 3 year old is matching patterns I honestly d", "My 3 year old is matching patterns I honestly didn't think she'd manage until kindergarten. The frame board is really smart, it keeps everything from sliding around while she works. Bought it for her, my 5 year old keeps stealing it."], /* thoson-shapecrew */
    ["My daughter grabbed these out of the box and di", "My daughter grabbed these out of the box and didn't look up for an hour. She squishes them, stacks little towers, knocks them down, and starts over. She's 3 and figuring out which shapes fit together completely on her own."], /* thoson-squishblocks */
    ["I was terrified of sand in my living room. This", "I was terrified of sand in my living room. This sand holds together, so my son molds castles and it doesn't scatter. Then we turned off the lights, the glow stones lit up and he SCREAMED with joy. Cleanup takes 10 seconds."], /* thoson-sandlab */
    ["The magnetic snap when pieces click together is", "The magnetic snap when pieces click together is honestly addictive. For my kids AND me. We've worked through like 30 patterns in 2 weeks. My 4 year old asks for it before TV, which still kind of shocks me."], /* thoson-pixelforge */
  ];

  /* Las comillas envolventes estaban en 13 de los 40, unas rectas y otras
     tipograficas, y en los otros 27 no habia ninguna. Se quitan las dos a
     la vez o ninguna, asi que una resena que acaba en apostrofo no se
     toca. */
  var Q_OPEN = /^["“‘']/;
  var Q_CLOSE = /["”’']$/;

  function reviews() {
    var nodes = document.querySelectorAll('.review-items-container .review-item__text p');
    Array.prototype.forEach.call(nodes, function (p) {
      if (p.getAttribute('data-thx-rev') === '1') return;
      var text = norm(p.textContent);

      for (var i = 0; i < REVIEW_SHORT.length; i++) {
        if (text.indexOf(REVIEW_SHORT[i][0]) === 0) {
          text = REVIEW_SHORT[i][1];
          break;
        }
      }

      if (Q_OPEN.test(text) && Q_CLOSE.test(text)) {
        text = text.slice(1, -1).trim();
      }

      if (text !== norm(p.textContent)) p.textContent = text;
      p.setAttribute('data-thx-rev', '1');
    });
  }

  /* ----------------------------------------------------------------
     6. "Why This Matters for Your Child", solo en movil.

     En un telefono las tarjetas van en rejilla de dos columnas, la columna
     de texto mide 138px y la descripcion ocupaba seis lineas. El bloque
     entero pasaba de 670px. Estas versiones cortas dicen lo mismo con un
     40% menos de texto: no se anade ninguna afirmacion que no estuviera
     ya, solo se quita relleno.

     En escritorio no se toca nada. El original se guarda en el elemento,
     asi que girar el telefono o abrir el inspector devuelve el texto largo
     sin recargar.
     ---------------------------------------------------------------- */
  var WHY_SHORT = {
    "Children choose purposeful work, build confidence, and learn to start and finish tasks on their own.": "They choose their own work and learn to finish what they start.",
    "Uninterrupted work cycles nurture calm focus, patience, and stick-with-it problem solving.": "Uninterrupted play builds calm focus and patience.",
    "Hands, eyes, and movement work together to refine perception, grounding future math, language, and logic.": "Hands, eyes and movement refine the senses math and language rest on.",
    "Precise, real-world actions (grasping, tracing, transferring) strengthen control, dexterity, and hand, eye alignment.": "Grasping, tracing and transferring build control and hand-eye coordination.",
    "Guaranteed no stains on anything except special paper, supports independent learning without constant supervision": "No stains on anything but the special paper, so they play unsupervised.",
    "Real tactile experience develops fine motor skills and spatial awareness, no passive consumption": "Real tactile play builds fine motor skills and spatial awareness.",
    "Interactive brush engages multiple senses simultaneously for deeper cognitive development": "The interactive brush engages several senses at once.",
    "Develops sustained attention and concentration skills that screens actually diminish": "Builds the sustained attention that screens diminish.",
    "Solid wooden blocks, real picture cards, real word-building. The hands-on method experts have recommended for 100+ years.": "Real wooden blocks and real word-building, backed for 100+ years.",
    "Picking up letters, lining them up, sounding them out. That physical motion is how kids ages 3 to 8 actually learn to read. Apps can't replicate it.": "Picking up letters and sounding them out is how kids 3 to 8 learn to read.",
    "Kids see the picture, feel the letter, say the sound, build the word. Four senses working together. That's how reading sticks for life.": "See the picture, feel the letter, say the sound, build the word.",
    "Builds the sustained attention that screens actively erode. Every word built is a small win for their developing brain.": "Builds the sustained attention that screens erode, one word at a time.",
    "Solid wood pieces, real frame board, real pattern matching. The hands-on method experts have recommended for 100+ years.": "Real wood pieces and real pattern matching, backed for 100+ years.",
    "Picking up shapes, rotating them, fitting them into the frame. That physical movement is how kids ages 3 to 8 build spatial thinking. Apps can't replicate it.": "Rotating shapes and fitting the frame is how kids 3 to 8 build spatial thinking.",
    "Kids see the card, find the shape, place it on the frame, check the match. Four steps working together. That's how spatial reasoning becomes second nature.": "See the card, find the shape, place it, check the match. Four steps, every time.",
    "Builds the sustained attention that screens actively erode. Every pattern solved is a small win for their developing brain.": "Builds the sustained attention that screens erode, one pattern at a time.",
    "Solid wood pieces with strong embedded magnets. No plastic snap-together junk that breaks in a month. Built to last through siblings, drops, and years of daily use.": "Solid wood with embedded magnets, built to last through siblings and drops.",
    "Picking pieces, rotating shapes, fitting them to the pattern. That physical motion is how kids ages 3 to 8 build the spatial thinking that prepares them for math and reading.": "Rotating and fitting pieces builds the spatial thinking math and reading need.",
    "Match patterns, freestyle build, sort by color, learn animal names, build 3D structures. One toy, dozens of ways to play. Kids do not get bored.": "Match, build, sort, name animals, go 3D. One toy, dozens of ways to play.",
    "Builds the sustained attention that screens actively erode. Every pattern completed is a small win for their developing brain.": "Builds the sustained attention that screens erode, one pattern at a time.",
    "Moldable sand stays in the bin, the lid seals it away. Independent play without the vacuum standing by.": "Moldable sand stays in the bin and the lid seals it away.",
    "Scooping, molding, digging, sorting. The tactile work that builds fine motor strength and hand-eye coordination before school asks for it.": "Scooping, molding and digging build fine motor strength and coordination.",
    "Stones charge in daylight and shine at night. Multi-sensory play that makes lights-off the best part of the day.": "Stones charge in daylight and shine at night, so lights-off is the best part.",
    "Develops sustained attention and concentration skills that screens actually diminish. One bin, one focused kid.": "Builds the attention screens diminish. One bin, one focused kid.",
    "100,000 answers across 6 science themes give kids the broad general knowledge that high-achieving students have.": "100,000 answers across 6 science themes, the broad knowledge top students have.",
    "Following a 'why' to its answer builds the lateral thinking and problem-solving that classrooms struggle to teach.": "Following a 'why' to its answer builds real problem-solving.",
    "Fun illustrations on every page mean kids read it for enjoyment, the rare science book that competes with a screen.": "Illustrations on every page, so they read it for fun, not for homework.",
    "No ads, no pop-ups, no rabbit holes. Curiosity leads somewhere good while eyes stay off the tablet.": "No ads, no pop-ups, no rabbit holes. Eyes stay off the tablet.",
    "A step-by-step ladder from first sounds to full sentences, so kids start where they are and climb at their own pace.": "From first sounds to full sentences, climbing at their own pace.",
    "Designed by educators and trusted by homeschool parents, with a proven order that actually builds reading skills.": "Designed by educators, in an order that actually builds reading skills.",
    "Bright pictures and quick games mean no eye-rolls and no resistance. Kids ask to practice without realizing it is schoolwork.": "Quick games, no eye-rolls. They ask to practice without noticing.",
    "Thick cards survive years and siblings, building real reading skills with zero screen time and nothing to charge.": "Thick cards survive years and siblings, with nothing to charge.",
    "Every word is spoken in a clear, friendly voice, so kids hear exactly how it should sound and copy it back.": "Every word in a clear, friendly voice, so they hear it and copy it back.",
    "Kids press repeat as many times as they need, pairing sound with picture until the word clicks and comes out.": "They press repeat as often as they need, until the word comes out.",
    "All the tapping and sounds kids love with no glowing screen, so you hand it over without the guilt.": "All the tapping and sound they love, with no glowing screen.",
    "Clips onto the ring for the car and charges by USB-C, so there are no batteries to buy or chase down.": "Clips on for the car and charges by USB-C. No batteries to chase.",
    "A gentle ding as the marbles fall, powered by nothing but gravity. No charging, no replacing, no noise to wear you down.": "A gentle ding as the marbles fall, powered by nothing but gravity.",
    "The tumbling marble captures their attention like a screen, but they control it, building focus and calm as they play.": "The tumbling marble holds them like a screen, except they control it.",
    "Solid wood with a non-toxic finish, sturdy enough for daily play and made to be handed down, not tossed out.": "Solid wood, non-toxic finish, made to be handed down and not tossed out.",
    "Rainbow leaves that look lovely on any shelf, giving your child real, quiet play with nothing to plug in.": "Rainbow leaves that look lovely on a shelf, with nothing to plug in.",
    "Holding a brush, loading it with water, controlling every stroke. The exact fine motor practice little hands need before writing.": "Holding a brush and controlling every stroke, the practice writing needs.",
    "They can set up, paint, and finish without help. Confidence grows every time they do the whole thing by themselves.": "They set up, paint and finish without help, and the confidence shows.",
    "Perforated pages turn every session into a finished piece they can hang up, frame, or proudly mail across the country.": "Perforated pages turn every session into a piece they can hang or mail.",
    "Quiet, focused painting instead of another episode. The kind of attention that carries into everything else they do.": "Quiet, focused painting instead of another episode.",
    "Load it, move it, dump it. Every action has a visible result, which is how little brains learn that the world responds to their hands.": "Load it, move it, dump it. Every action has a result they can see.",
    "Designing a route, fixing a corner that will not connect, replanning the layout. Real engineering thinking, disguised as play.": "Designing a route and fixing what will not connect. Engineering as play.",
    "The load-haul-dump cycle always leaves one more delivery to make, and that unfinished run is what keeps them locked in.": "The load-haul-dump cycle always leaves one more delivery to make.",
    "Every session becomes a site with jobs, schedules, and announcements. Pretend play with a working set underneath it.": "Every session becomes a site with jobs and schedules of their own.",
    "The more your child eats, the more snake they have to steer. Being in the lead turns into its own handicap.": "The more they eat, the more snake to steer. The lead is its own handicap.",
    "Nobody sits out and nobody watches a clock. They compete against each other instead of waiting on each other.": "Nobody sits out. They compete against each other, not against a clock.",
    "Magnets hold the tail together, so a knocked-off block lands in plain sight and goes straight back on. Nothing disappears under the couch.": "Magnets hold the tail, so a knocked-off block goes straight back on.",
    "Lights, sound effects, and two kids on the rug shouting about a yellow block. Quiet was never the goal here.": "Lights, sound and two kids shouting about a yellow block.",
    "Fill the tank with plain water, press the button, and seven LED colors light the cloud as it rolls out of the dinosaur.": "Plain water in the tank, and seven LED colors light the cloud rolling out.",
    "Four things to control from one small remote, so there is always another button to press and another game to invent.": "Four things to control from one remote, and another game to invent.",
    "A chunky body kids grab with both hands, made from non-toxic materials, sized to be carried back to the starting line again and again.": "A chunky non-toxic body, sized for two hands to carry back again and again.",
    "No app, no tablet, nothing to pair. Just a remote, a dinosaur, and a kid on the floor making up the hunt out loud.": "No app, nothing to pair. A remote, a dinosaur and a kid on the floor.",
    "Press the lit bubbles before the round runs out, then push the raised cover on the back to move up to a faster level.": "Press the lit bubbles before the round runs out, then move up a level.",
    "Switch modes and the bubbles light up in a pattern your child has to press back in order, one longer every round.": "Switch modes and they press the pattern back, one longer every round.",
    "A sound button on the front turns it down or off completely, so the game fits the car, the table, or the backyard.": "A sound button turns it down or off, so it fits the car or the table.",
    "An ABS shell with soft silicone bubbles, shaped to sit in one hand and wipe clean when it comes back out.": "An ABS shell with silicone bubbles, sized for one hand and easy to wipe.",
    "The train drives forward and sets tiles down at an even gap, which is the one part small hands cannot do.": "The train sets the tiles at an even gap, the part small hands cannot do.",
    "Fill the second tray while the first is still running so the row keeps growing instead of stopping.": "Fill the second tray while the first runs, so the row never stops.",
    "Smooth edged ABS tiles that also stack into towers, letters and numbers when the train is off.": "Smooth ABS tiles that also stack into towers, letters and numbers.",
    "Two AA batteries and a switch. Nothing to pair, nothing to download, nothing to charge overnight.": "Two AA batteries and a switch. Nothing to pair or download.",
    "Every door leaves something behind, so the month builds into a row instead of ending in an empty tray.": "Every door leaves something behind, so the month builds into a row.",
    "A different character behind every door, so the late days are as good as the first week.": "A different character behind every door, all the way to the last one.",
    "Made to be squeezed, which is why they end up in pockets, on desks and in the car long after December.": "Made to be squeezed, which is why they outlast December.",
    "Nothing to charge, nothing to pair, nothing to download. Open the door and that is the whole thing.": "Nothing to charge or pair. Open the door and that is the whole thing.",
  };

  function whyCards(on) {
    var cards = document.querySelectorAll('.icon-bar-card .multicolumn-card__info .rte p');
    Array.prototype.forEach.call(cards, function (p) {
      if (on) {
        if (p.hasAttribute('data-thx-full')) return;
        var short = WHY_SHORT[norm(p.textContent)];
        if (!short) return;
        p.setAttribute('data-thx-full', p.textContent);
        p.textContent = short;
      } else if (p.hasAttribute('data-thx-full')) {
        p.textContent = p.getAttribute('data-thx-full');
        p.removeAttribute('data-thx-full');
      }
    });
  }

  var mq = window.matchMedia ? window.matchMedia(MOBILE) : null;

  function runAll() {
    heroCta();
    navTitle();
    screenBand();
    urgencyTag();
    reviews();
    whyCards(mq ? mq.matches : false);
  }

  runAll();

  if (mq) {
    var onChange = function () { whyCards(mq.matches); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  /* El editor de temas vuelve a pintar la seccion entera, y un cambio de
     variante vuelve a pintar el buy box. Ninguno de los dos avisa igual,
     asi que se escuchan los dos y todo lo de arriba es idempotente. */
  document.addEventListener('shopify:section:load', runAll);

  var main = document.getElementById('MainContent');
  if (main && window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        runAll();
      });
    }).observe(main, { childList: true, subtree: true });
  }
})();